import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import docuwarePartner from "@/assets/docuware-partner-2026.webp";
import docuwareExpert2026 from "@/assets/docuware-expert-2026.webp";
import docuwareExpert2025 from "@/assets/docuware-expert-2025.webp";

const benefits = [
  "Facturas sin papel: procesamiento automatizado",
  "Acceso centralizado desde cualquier ubicación",
  "Integración con ERP y CRM existentes",
  "Seguridad y cumplimiento normativo",
  "Ideal para pequeñas y medianas empresas",
];

const DocuWareSection = () => (
  <section id="docuware" className="py-24 bg-background overflow-visible">
    <div className="container">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm font-semibold tracking-wider uppercase text-primary mb-3 block">
            DocuWare Authorized Partner
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-6">
            La nueva dimensión del trabajo moderno
          </h2>
          <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
            DocuWare ofrece eficiencia y transparencia para todos los documentos corporativos.
            No importa dónde trabajen tus empleados, la integración perfecta y el acceso
            centralizado mantienen a todo el equipo alineado.
          </p>

          <ul className="space-y-4">
            {benefits.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-primary shrink-0 mt-0.5" />
                <span className="text-foreground">{b}</span>
              </li>
            ))}
          </ul>

          <a
            href="#contacto"
            className="inline-flex items-center justify-center rounded-lg bg-primary px-7 py-3.5 text-base font-semibold text-primary-foreground hover:bg-primary/90 transition-colors mt-10"
          >
            Solicitar Demo
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center gap-10"
        >
          {/* Partner Badge - displayed at full width */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-border/50 w-full max-w-md">
            <img
              src={docuwarePartner}
              alt="DocuWare Authorized Partner 2026"
              width={600}
              height={210}
              className="w-full h-auto object-contain"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Technical Expert Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="bg-white rounded-2xl p-4 shadow-lg border border-border/50">
              <img
                src={docuwareExpert2026}
                alt="DocuWare Technical Expert Setup 2026"
                width={280}
                height={280}
                className="w-40 h-40 object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="bg-white rounded-2xl p-4 shadow-lg border border-border/50">
              <img
                src={docuwareExpert2025}
                alt="DocuWare Technical Expert Setup 2025"
                width={280}
                height={280}
                className="w-40 h-40 object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default DocuWareSection;
